export const handleScroll = (blockId: string) => {
  let indicator = null;
  if (document.querySelector(`#trajectory_block_${blockId}`)) {
    indicator = document.querySelector(`#trajectory_block_${blockId}`);
  } else if (document.querySelector(`#block_wrapper-${blockId}`)) {
    indicator = document.querySelector(`#block_wrapper-${blockId}`);
  }

  if (!indicator) return;
  indicator.scrollIntoView({
    behavior: 'smooth',
  });
};
